import { API_endpoints } from "../config";

export const statistic4 = async ( startDate = "", endDate = ""): Promise<any> => {
    try {
        const response = await fetch(API_endpoints.statistic4, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({startDate,endDate}),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von statistik 4 Daten.");
        }
    

        return await response.json();

        
    } catch (error) {
        console.error("Fehler beim Laden von statistik 4 Daten:", error);
    }
};
